import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({ title, description, path, image, author }) => {
  const data = useStaticQuery(query);

  const defaults = data.site.siteMetadata;

  if (defaults.siteUrl === '' && typeof window !== 'undefined') {
    defaults.siteUrl = window.location.origin;
  }

  if (defaults.siteUrl === '') {
    console.error('Please set a siteUrl in your site metadata!');
    return null;
  }

  const titleFinal = title || defaults.title;
  const descriptionFinal = description || defaults.description;
  const urlFinal = new URL(path || '', defaults.siteUrl);
  const imageFinal = image ? new URL(image, defaults.siteUrl) : false;
  const authorFinal = author || defaults.author;

  return (
    <Helmet>
      <html lang="en" />
      <title>{titleFinal}</title>
      <link rel="canonical" href={urlFinal} />
      <meta name="description" content={descriptionFinal} />
      {imageFinal && <meta name="image" content={imageFinal} />}

      <meta property="og:url" content={urlFinal} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={titleFinal} />
      <meta property="og:description" content={descriptionFinal} />
      {imageFinal && <meta property="og:image" content={imageFinal} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={authorFinal.twitter} />
      <meta name="twitter:title" content={titleFinal} />
      <meta name="twitter:description" content={descriptionFinal} />
      {imageFinal && <meta name="twitter:image" content={imageFinal} />}
    </Helmet>
  );
};

export default Seo;

const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
        siteUrl
        author {
          twitter
        }
      }
    }
  }
`;
